import React, { useCallback, useEffect, useState, useMemo } from 'react';
import {
  Box,
  ButtonBase,
  Button,
  Card,
  IconButton,
  Drawer,
  List,
  Paper,
  Container,
  Typography,
  Chip,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { LatLngBoundsLiteral, LatLngTuple } from 'leaflet';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { startOfYear } from 'date-fns';
import { format } from 'date-fns-tz';
import { optionStyles } from './styles';
import LeftArrow from '../../assets/leftArrow.svg';
import MapContent, { DrawPolygonType } from '../../components/MapContent';
import FilterBar, { EngFilterOpsType } from '../../components/FilterBar';
import ChartGenerator from '../../components/ChartsGenerator';
import {
  chartDataObject,
  mapInformationChartDataObject,
  multilineData,
} from '../../@types/chartData';
import api from '../../services/api';
import { IChartState } from '../../store/modules/chart/types';
import { addChartsToExport } from '../../store/modules/chart/action';
import { jsonb as JsonbType } from '../../@types/jsonb';
import { MapInformation } from '../../@types/records';
import { fetchIncidentsTileKey } from '../../actions/incidentActions';
import { fetchEngMapInformationChart, fetchEngMapInformationPointLine, fetchEngineeringsTileKey } from '../../actions/engineeringActions';
import { engGraphics } from '../../actions/engineeringActions';
import { getFilterDates } from '../../actions/managementActions';

interface ResponseManagement {
  uuid: string;
  datetime_begin: string;
  datetime_end: string;
  datetime_map_begin: string;
  datetime_map_end: string;
}

const initialJsonb: JsonbType = {
  jsonb: {
    driverEngineeringIntervention: {
      Tipo: {
        _rule_type: 'containment',
        contains: [],
      },
      Especificação: {
        _rule_type: 'containment',
        contains: [],
      },
    },
    driverEngineeringInterventionProject: {
      Status: {
        _rule_type: 'containment',
        contains: ['', ['']],
      },
      'Identificador do Projeto': {
        _rule_type: 'containment',
        contains: [],
      },
    },
    driverEngineeringLocation: {
      'Endereço 1': {
        _rule_type: 'containment',
        contains: [],
      },
    },
    driverEngineeringInterventionRequest: {
      'Número do Protocolo': {
        _rule_type: 'containment',
        contains: [],
      },
    },
  },
};

const initialFilterOps: EngFilterOpsType = {
  endDate: '',
  startDate: '',
  especificacao: [],
  tipo: [],
  status: [],
  bairros: '',
  endereco: '',
  protocolo: [],
  identificador: [],
  solicitante: '',
  drawPolygon: {},
};

const loadFilterOps = (): EngFilterOpsType => {
  let filterOpsObj: EngFilterOpsType = initialFilterOps;
  const loadedFilterOps = localStorage.getItem('engFilterOps');

  if (loadedFilterOps) {
    filterOpsObj = JSON.parse(loadedFilterOps);
  }

  return filterOpsObj;
};

const loadJsonbStorage = (): JsonbType => {
  const loadedFilterOps = localStorage.getItem('engFilterOps');
  let jsonbObj: JsonbType = initialJsonb;

  if (loadedFilterOps) {
    const parsedFilters: EngFilterOpsType = JSON.parse(loadedFilterOps);

    const especificacao: Array<string | string[]> = [];
    const tipo: Array<string | string[]> = [];
    const status: Array<string | string[]> = [];

    parsedFilters.especificacao.map((item) => {
      especificacao.push(item);
      especificacao.push([item]);
    });

    parsedFilters.tipo.map((item) => {
      tipo.push(item);
      tipo.push([item]);
    });

    parsedFilters.status.map((item) => {
      status.push(item);
      status.push([item]);
    });

    jsonbObj = {
      jsonb: {
        driverEngineeringInterventionProject: {
          Status: {
            _rule_type: 'containment_multiple',
            contains: status,
          },
        },
        driverEngineeringIntervention: {
          Especificação: {
            _rule_type: 'containment_multiple',
            contains: especificacao,
          },
          Tipo: {
            _rule_type: 'containment_multiple',
            contains: tipo,
          },
        },
      },
    };
    return jsonbObj;
  }
  return jsonbObj;
};

const MapEngineering: React.FC = () => {
  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);

  const defaultStartDate = `${process.env.REACT_APP_MAP_START_DEFAULT_DATE}`;
  const defaultEndDate = `${process.env.REACT_APP_MAP_END_DEFAULT_DATE}`;
  const classes = optionStyles();
  const [openMenu, setOpenMenu] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [loading0, setLoading0] = useState<boolean>(true);
  const [loading1, setLoading1] = useState<boolean>(true);
  const [openTable, setOpenTable] = useState<boolean>(true);
  const [openTableResp, setOpenTableResp] = useState<boolean>(false);
  const [legendY, setLegendY] = useState<string>('');
  const [mapInformationChart, setMapInformationChart] = useState<
    mapInformationChartDataObject[]
  >([]);
  const [mapInformation, setMapInformation] = useState<MapInformation[]>([]);
  const [typeChart, setTypeChart] = useState<chartDataObject[]>([]);
  const [monthChart, setMonthChart] = useState<multilineData[]>([]);
  const [jsonb, setJsonb] = useState<JsonbType>(loadJsonbStorage());
  const [address, setAddress] = useState<string>('');
  const [requester, setRequester] = useState<string>('');
  const [dateMin, setDateMin] = useState<string>(defaultStartDate);
  const [dateMax, setDateMax] = useState<string>(defaultEndDate);
  const [position, setPosition] = React.useState<LatLngTuple>([0, 0]);
  const [zoom, setZoom] = useState<number>(0);
  const [drawPolygon, setDrawPolygon] = useState<DrawPolygonType | {}>(
    loadFilterOps().drawPolygon,
  );
  const [boundary_polygon, setBoundary_polygon] = useState<{}>({
    polygon_id: loadFilterOps().bairros,
  });
  const [bboxPolygon, setBboxPolygon] = useState<LatLngBoundsLiteral>([
    [0, 0],
    [0, 0],
  ]);

  const [admin, setAdmin] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [publicGroup, setPublicGroup] = useState<boolean>(false);
  const [startDateMap, setStartDateMap] = useState<string>('2014-01-01T00:00:00Z');
  const [endDateMap, setEndDateMap] = useState<string>('2020-06-30T23:59:59.999000Z');
  const [loadingDate, setloadingDate] = useState<boolean>(true);
  const history = useHistory();
  const dispatch = useDispatch();

  const filterOps: EngFilterOpsType = loadFilterOps();

  const params = useMemo(() => {
    return {
      occurred_min: filterOps.startDate || dateMin,
      occurred_max: filterOps.endDate || dateMax,
      requester,
      address,
      ...jsonb,
      ...boundary_polygon,
      ...drawPolygon,
    };
  }, [
    filterOps.startDate,
    filterOps.endDate,
    dateMin,
    dateMax,
    jsonb,
    boundary_polygon,
    drawPolygon,
  ]);

  useEffect(() => {
    const groups = localStorage.getItem('groups')?.split(' ');
    if (groups) {
      groups.forEach((gr: string) => {
        if (gr === 'public') {
          setPublicGroup(true);
        } else if (gr === 'digitador') {
          setTypist(true);
        } else if (gr === 'tec_engenharia') {
          setTecEng(true);
        } else if (gr === 'geofi') {
          setGeofi(true);
        } else if (gr === 'admin') {
          setAdmin(true);
        }
      });
    }
  }, []);

  if (publicGroup && !(admin || geofi || tecEng || typist)) {
    history.push('/mapa/sinistros');
  }

  const fetchManagementDate = useCallback(async () => {
    setloadingDate(true);
    try {
      const dates = await getFilterDates(filterOps.startDate, filterOps.endDate);
      setDateMin(dates.dateMin);
      setDateMax(dates.dateMax);
      setStartDateMap(dates.startDateMap);
      setEndDateMap(dates.endDateMap);
    } catch {
      console.log("error");
    } finally {
      setloadingDate(false);
    }

  }, [filterOps.startDate, filterOps.endDate]);

  const requestGetMapInformation = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchEngMapInformationPointLine({params});
      setMapInformation(response.data);
    } catch (error) {
      setMapInformation([]);
    } finally {
      setLoading(false);
    }

  }, [params, authHeader]);

  const requestGetMapInformationChart = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchEngMapInformationChart({params});
      setMapInformationChart(response.data);
    } catch (error) {
      setMapInformationChart([]);
    } finally {
      setLoading(false);
    }
  }, [params, authHeader]);

  useEffect(() => {
    fetchManagementDate();
  }, [fetchManagementDate]);

  useEffect(() => {
    if (!loadingDate) {
      requestGetMapInformation();
    }
  }, [loadingDate, requestGetMapInformation]);

  useEffect(() => {
    if (!loadingDate) {
      requestGetMapInformationChart();
    }
  }, [loadingDate, requestGetMapInformationChart]);

  const names: IChartState = {
    charts: [
      {
        img: 'BarChartHorizontalIcon',
        name: 'Perfil dos usuários envolvidos por severidade',
        chartType: 'barh',
        legendY: '',
        legendOne: ' ',
        percent: false,
        chart: typeChart,
      },
      {
        img: 'LineChartIcon',
        name: 'Intervenções concluídas por mês',
        chartType: 'multiline',
        legendY: '',
        legendOne: ' ',
        percent: false,
        multi: monthChart,
      },
    ],
  };

  const handleAddChartsToExport = useCallback(
    (charts: IChartState) => {
      dispatch(addChartsToExport(charts));
      history.push('/exportador');
    },
    [dispatch, history],
  );

  return (
    <>
      <FilterBar
        filterJson={setJsonb}
        dateMinSet={setDateMin}
        dateMaxSet={setDateMax}
        setPositionSearch={setPosition}
        zoom={setZoom}
        id_boundary={setBoundary_polygon}
        bbox_boundary={setBboxPolygon}
        routeTo="engenharia"
        startDateMap={startDateMap}
        endDateMap={endDateMap}
        drawPolygon={drawPolygon}
        setDrawPolygon={setDrawPolygon}
        setRequester={setRequester}
        requester={requester}
        address={address}
        setAddress={setAddress}
      />
      <Container className={classes.responsiveButton}>
        <Chip
          title="Intervenções de Engenharia"
          label="Intervenções de Engenharia"
          className={classes.pageNameChip}
        />
        <ButtonBase
          className={classes.responsivemenuButton}
          onClick={() => {
            setOpenMenu(openMenu === 1 ? 0 : 1);
          }}
        >
          Gráficos
        </ButtonBase>
        <ButtonBase
          className={classes.responsivemenuButton}
          onClick={() => setOpenMenu(openMenu === 2 ? 0 : 2)}
        >
          Exportar
        </ButtonBase>
        <ButtonBase
          onClick={() => {
            openTableResp ? setOpenTableResp(false) : setOpenTableResp(true);
          }}
          className={`${classes.responsivemenuButton} ${
            openTableResp ? classes.tableOpen : classes.tableClosed
          }`}
        >
          <img
            className={classes.tableButonIcon}
            src={LeftArrow}
            alt="Right"
            style={{ transform: `${openTableResp ? 'rotate(0deg)' : 'rotate(180deg)'}` }}
          />
          {openTableResp ? (
            <>
              <Typography variant="h6" className={classes.tableText}>
                Fechar aba lateral
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h6" className={classes.tableText}>
                Abrir aba lateral
              </Typography>
            </>
          )}
        </ButtonBase>
      </Container>
      <div>
        <MapContent
          content={mapInformation}
          pageName="Intervenções de Engenharia"
          occurred_min={dateMin}
          occurred_max={dateMax}
          jsonb={jsonb}
          polygon={setDrawPolygon}
          positionSearch={position}
          zoomSearch={zoom}
          polygon_id={boundary_polygon}
          bbox={bboxPolygon}
          type={`${process.env.REACT_APP_ENG_RECORD_TYPE}`}
          apiName="engenharia"
          registerName="Intervenções"
          loadingMap={loadingDate}
          config={{params}}
          fetchTileKeyRequest={fetchEngineeringsTileKey}
        />
      </div>

      <>
        <Box
          className={`${classes.tableButton} ${
            openTable ? classes.tableOpen : classes.tableClosed
          }`}
        >
          <IconButton
            className={classes.button}
            onClick={() => (openTable ? setOpenTable(false) : setOpenTable(true))}
          >
            <img className={classes.tableButonIcon} src={LeftArrow} alt="Right" />
          </IconButton>
        </Box>
        <Drawer
          anchor="right"
          open={openTable}
          variant="persistent"
          ModalProps={{ BackdropProps: { invisible: true } }}
          PaperProps={{ className: classes.tableDrawer }}
        >
          {/* Card referente aos dados do Mapa */}
          <List>
            {mapInformationChart.map((obj) => (
              <Paper className={classes.accidentCard} key={`${obj.label} ${obj.value}`}>
                <Box className={classes.accidentLabel}>{obj.label}</Box>
                <Box className={classes.accidentValue}>{obj.value.toLocaleString('pt-BR')}</Box>
              </Paper>
            ))}
          </List>
        </Drawer>

        <Drawer
          anchor="right"
          open={openTableResp}
          variant="persistent"
          ModalProps={{ BackdropProps: { invisible: true } }}
          PaperProps={{ className: classes.tableDrawerResp }}
        >
          <List>
            {mapInformationChart.map((obj) => (
              <Paper className={classes.accidentCard} key={`${obj.label} ${obj.value}`}>
                <Box className={classes.accidentLabel}>{obj.label}</Box>
                <Box className={classes.accidentValue}>{obj.value}</Box>
              </Paper>
            ))}
          </List>
        </Drawer>
      </>
      <Box className={classes.footerMenu}>
        {openMenu === 1 && (
          <Card className={classes.chartsMenu} elevation={0}>
            <Button
              onClick={() => setOpenMenu(0)}
              className={classes.buttonCloseResponsive}
            >
              Fechar
            </Button>
            <div style={{ display: 'flex', backgroundColor: 'transparent' }}>
              <ChartGenerator
                params={params}
                charts={[
                  {
                    title: 'Perfil dos usuários envolvidos por severidade',
                    chartType: 'barh',
                    legendY: '',
                    percent: false,
                    chart: typeChart,
                    request: engGraphics.engenhariaTipo,
                    setChart: setTypeChart,
                    loading: loading0,
                    setLoading: setLoading0,
                    setlegend: setLegendY,
                  },
                  {
                    title: 'Intervenções concluídas por mês',
                    chartType: 'multiline',
                    legendY: '',
                    percent: false,
                    multi: monthChart,
                    request: engGraphics.engenhariaMes,
                    setChart: setMonthChart,
                    loading: loading1,
                    setLoading: setLoading1,
                    setlegend: setLegendY,
                  },
                ]}
              />
              <IconButton className={classes.buttonClose} onClick={() => setOpenMenu(0)}>
                <Close />
              </IconButton>
            </div>
          </Card>
        )}

        {openMenu === 2 && (
          <Card className={classes.exportPalette} elevation={0} style={{ left: 103 }}>
            <Button
              variant="outlined"
              className={`${classes.buttonPalette} ${classes.cancel}`}
              onClick={() => setOpenMenu(0)}
            >
              Fechar
            </Button>
            <Button
              variant="outlined"
              type="submit"
              className={classes.buttonPalette}
              onClick={() => handleAddChartsToExport(names)}
            >
              PDF
            </Button>
          </Card>
        )}
        <ButtonBase
          className={`${classes.menuButton} ${
            openMenu === 1 ? classes.footerMenuActive : ''
          }`}
          onClick={() => {
            setOpenMenu(openMenu === 1 ? 0 : 1);
          }}
        >
          Gráficos
        </ButtonBase>
        <ButtonBase
          className={`${classes.menuButton} ${
            openMenu === 2 ? classes.footerMenuActive : ''
          }`}
          onClick={() => setOpenMenu(openMenu === 2 ? 0 : 2)}
        >
          Exportar
        </ButtonBase>
      </Box>
    </>
  );
};

export default MapEngineering;
